module.exports = __webpack_public_path__ + "static/aurelie-eaead0d2f4c46e5b8d4993ed33e6abf6.png";